<div fxLayout="column" fxLayoutAlign="start start" class="w-100" fxLayoutGap="8px">
    <div class="h-40 w-100 radius-8 t2-semi-bold"
         fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px"
         [class.bc-mono-white]="['quarter', 'month'].includes(column)"
         [class.bc-primary-gray-100]="column === 'forecastFuture'"
         [class.bc-primary-green-100]="column === 'forecastPast'"
         [class.pointer]="['forecastFuture', 'forecastPast', 'customRange'].includes(column)"
         (mouseenter)="['forecastFuture', 'forecastPast', 'customRange'].includes(column) && tooltip?.show()"
         (mouseleave)="['forecastFuture', 'forecastPast', 'customRange'].includes(column) && tooltip?.hide()">
        <div>{{ 'i18n_af_labelClassificationTableHeader#' + headerPostfix | translate }}</div>
        @if (['forecastFuture', 'forecastPast', 'customRange'].includes(headerPostfix)) {
            <ui-kit-svg class="i-16 c-secondary-red-800" name="ic_help"
                        #tooltip="matTooltip"
                        [matTooltip]="tooltipText | translate"
                        matTooltipClass="pre-line"/>
        }
    </div>
    <af-date-range-picker-field iconPosition="left"
                                class="w-100" [form]="form"
                                [hasPickerActions]="false"
                                [startDate]="startDate"
                                [endDate]="endDate"
                                [minDate]="minDate.toDate()"
                                [maxDate]="maxDate.toDate()"
                                [isDisabled]="['forecastFuture', 'forecastPast'].includes(this.column)"
                                [hasDynamicWidth]="false"
                                [hasTime]="false"/>
</div>
